import React, { forwardRef, useEffect, useMemo, useState } from 'react';
import { Flag, StyledNationalitySelect, StyledNationalitySelectLabel, StyledSelect, Wrapper } from './styles';
import { findCountryByAlpha3Code, getSortedCountries } from '@src/common/auth';

type NationalitySelectProps = {
  label?: string;
  name?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
};

const NationalitySelect = forwardRef<HTMLSelectElement, NationalitySelectProps>(
  (props: NationalitySelectProps, inputRef: React.Ref<HTMLSelectElement>) => {
    const { label, name, value, onChange } = props;

    const [internalValue, setInternalValue] = useState<string | undefined>(value);

    const selectedCountry = useMemo(() => findCountryByAlpha3Code(internalValue ?? ''), [internalValue]);
    const sortedCountries = useMemo(() => getSortedCountries(), []);

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
      setInternalValue(e.target.value);

      if (onChange) {
        onChange(e);
      }
    };

    useEffect(() => {
      setInternalValue(value);
    }, [value]);

    return (
      <Wrapper>
        {label ? <StyledNationalitySelectLabel>{label}</StyledNationalitySelectLabel> : null}

        <StyledSelect>
          <Flag>
            <img src={selectedCountry?.image} alt={selectedCountry?.name} />
          </Flag>

          <StyledNationalitySelect name={name} value={internalValue} onChange={handleChange} ref={inputRef}>
            <option key={`country-undefined`} value={undefined} disabled></option>

            {sortedCountries.map((country) => (
              <option key={`country-${country.alpha3}`} value={country.alpha3}>
                {country.name}
              </option>
            ))}
          </StyledNationalitySelect>
        </StyledSelect>
      </Wrapper>
    );
  },
);

NationalitySelect.displayName = 'NationalitySelect';

export default NationalitySelect;
